import { ReactNode } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ThemeProvider from "./theme/ThemeProvider";
import Store from "../store/Store";
import GlobalAlertsProvider from "./GlobalAlertsProvider";
import LiveChatProvider from "./LiveChatProvider";
import ScrollToTopProvider from "./ScrollToTopProvider";
import { Authenticator } from "@aws-amplify/ui-react";
import { ContextProvider } from "../../context/providers/ContextProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 30,
      retry: window.Cypress ? false : 1,
      refetchOnWindowFocus: false,
    },
  },
});

function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <Authenticator.Provider>
        <Router>
          <ContextProvider>
            <Store>
              <ThemeProvider>
                <GlobalAlertsProvider />
                <ScrollToTopProvider />
                <LiveChatProvider />
                {children}
              </ThemeProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </Store>
          </ContextProvider>
        </Router>
      </Authenticator.Provider>
    </QueryClientProvider>
  );
}

export default Providers;
